import { ComponentConfirmationState } from "@redotech/redo-support-common/conversation";
import { Schema } from "effect";

// eslint-disable-next-line @redotech/no-re-exports -- TODO: remove re-export, update all import sites
export { RedoChatMessage } from "./redo-chat-message";

/**
 * Reuses v1's `ComponentConfirmationState` enum so confirmation-state
 * values flow through v1 (AI agent, message parsers) and v2 (CRDB
 * `message_redo_chat.confirmation_state`) without cross-boundary
 * conversion. The enum's string values (`"pending"`, `"confirmed"`,
 * `"rejected"`) match the CRDB enum 1:1.
 */
export const MessageRedoChatConfirmationState = Schema.Enums(
  ComponentConfirmationState,
);
export type MessageRedoChatConfirmationState =
  typeof MessageRedoChatConfirmationState.Type;
